import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Layout } from '../../components/layout/Layout';
import { WritingChecksHistoryContent } from '../../components/grammar/WritingChecksHistoryPanel';
import { ROUTES } from '../../utils/constants';

export const WritingHistoryPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Layout>
      <div className="w-full h-full flex flex-col min-h-0 px-4 sm:px-6 py-4">
        <div className="flex items-center gap-4 shrink-0 mb-4">
          <button
            type="button"
            onClick={() => navigate(ROUTES.STUDENT_WRITING)}
            className="inline-flex items-center gap-2 h-9 px-4 py-2 rounded-xl border border-slate-200 dark:border-slate-700 hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-600 dark:text-slate-400 text-sm font-medium"
            aria-label="Back to Writing"
          >
            <ArrowLeft className="w-4 h-4" />
            Back
          </button>
          <h1 className="text-2xl sm:text-3xl font-extrabold text-slate-900 dark:text-slate-100">
            Writing check history
          </h1>
        </div>

        <div className="flex flex-col flex-1 min-h-0 w-full">
          <WritingChecksHistoryContent active={true} />
        </div>
      </div>
    </Layout>
  );
};

export default WritingHistoryPage;
